export default __webpack_public_path__ + "static/media/BrainBreak cards44.3b539c6a.png";